export const cartFragment = /* GraphQL */ `
  fragment CartFields on Cart {
    id
    attributes {
      key
      value
    }
    buyerIdentity {
      countryCode
      email
    }
    discountCodes {
      code
      applicable
    }
    discountAllocations {
      discountedAmount {
        amount
        currencyCode
      }
    }
    lines(first: 250) {
      edges {
        node {
          id
          quantity
          attributes {
            key
            value
          }
          cost {
            totalAmount {
              amount
              currencyCode
            }
            subtotalAmount {
              amount
              currencyCode
            }
            amountPerQuantity {
              amount
              currencyCode
            }
            compareAtAmountPerQuantity {
              amount
              currencyCode
            }
          }
          merchandise {
            ... on ProductVariant {
              id
              title
              priceV2 {
                amount
                currencyCode
              }
              price {
                amount
                currencyCode
              }
              image {
                url
                altText
                width
                height
              }
              product {
                title
                images(first: 1) {
                  edges {
                    node {
                      url
                      altText
                      width
                      height
                    }
                  }
                }
                metafields(
                  identifiers: [
                    { namespace: "custom", key: "original_price" }
                    { namespace: "custom", key: "max_quantity" }
                    { namespace: "custom", key: "flavor" }
                    { namespace: "descriptors", key: "subtitle" }
                  ]
                ) {
                  id
                  key
                  namespace
                  value
                }
              }
              sellingPlanAllocations(first: 10) {
                edges {
                  node {
                    sellingPlan {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
          sellingPlanAllocation {
            sellingPlan {
              id
              name
            }
          }
          discountAllocations {
            discountedAmount {
              amount
              currencyCode
            }
          }
        }
      }
    }
    checkoutUrl
    cost {
      totalAmount {
        amount
        currencyCode
      }
      subtotalAmount {
        amount
        currencyCode
      }
      totalTaxAmount {
        amount
        currencyCode
      }
      totalDutyAmount {
        amount
        currencyCode
      }
    }
  }
`;
